import { useMutation, useQueryClient } from '@tanstack/react-query';
import { profileApi, type UpdateProfileBody, type ChangePasswordBody } from '@/features/profile/api';
import { notify } from '@/lib/notify';
import { apiErrorMessage } from '@/api/errors';

export function useUpdateProfile() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (b: UpdateProfileBody) => profileApi.update(b),
    onSuccess: () => { qc.invalidateQueries({ queryKey: ['auth', 'me'] }); notify.success('Profile updated'); },
    onError: (e) => notify.error(apiErrorMessage(e, 'Could not update profile')),
  });
}

export function useChangePassword() {
  return useMutation({
    mutationFn: (b: ChangePasswordBody) => profileApi.changePassword(b),
    onSuccess: () => notify.success('Password changed'),
    onError: (e) => notify.error(apiErrorMessage(e, 'Could not change password')),
  });
}
